module.exports = __webpack_public_path__ + "media/images/massage/cover-desktop-faa735881869283edf06fce8b1fe221f.jpg";